<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        {{ popupTitle }}
      </h3>

      <d-row>
        <div class="form-group w-100">
          <label for="start">Note:</label>
          <d-textarea
            v-model="data.notes"
            :value.prop="data.notes" />
        </div>
      </d-row>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="submitForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'NotePopup',
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        return 'Add note';
      }

      return 'Edit note';
    }
  },
  data () {
    return {
      isVisible: false,
      loading: false,
      mode: 'add',
      flight_id: 0,
      type: '',
      data: {
        id: null,
        notes: '',
        person_type: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-note-popup', this.show);
  },
  methods: {
    show (mode, noteType, noteData) {
      this.loading = false;
      this.mode = mode;
      this.flight_id = noteData.flight_id;
      this.type = noteType;
      this.data = {
        id: noteData.id,
        notes: noteData[noteType],
        person_type: noteData.person_type
      };

      setTimeout(() => {
        this.isVisible = true;
      }, 100);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/trips/passengers/update/' + this.data.id;

      if (this.data.person_type === 'CREW') {
        endpointUrl = '/trips/crews/update/' + this.data.id;
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Note added' : 'Note saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save this note. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('pax-list-reload-needed');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        flight_id: this.flight_id,
        [this.type]: this.data.notes,
        person_type: this.data.person_type
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-note-popup', this.show);
  }
}
</script>
